<template>
  <v-dialog class="blur-dialog" transition="fade-transition" persistent :value="value" @input="$emit('input', false)" fullscreen dark>
    <v-card style="background: rgba(21, 21, 21, 0.7); backdrop-filter: blur(10px)" flat class="d-flex flex-column fill-height">
      <v-toolbar dark color="transparent" flat>
        <v-spacer></v-spacer>
        <v-btn icon large @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="flex-grow-1 pa-0 zoom-container" :class="{ 'is-zoomed': isZoomed }">
        <SecuredMedia
          vif="item"
          noObserver
          :filename="item.fileUrl"
          :mediaType="item.messageType"
          class="fullscreen-media-content"
          :class="{ 'zoomed-in': isZoomed }"
          @click.native.stop="toggleZoom" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SecuredMedia from "./securedMedia.vue"

export default {
  name: "MediaViewerDialog",
  components: { SecuredMedia },
  props: {
    value: Boolean, // Für v-model
    item: {
      type: Object,
      default: null,
    },
  },

  // --- START: NEUE LOGIK ---
  data() {
    return {
      isZoomed: false,
    }
  },

  watch: {
    /**
     * Setzt den Zoom zurück, wenn der Dialog geschlossen wird.
     */
    value(newValue) {
      if (!newValue) {
        // Verzögerung, damit der Reset nicht während der
        // Schließen-Animation sichtbar ist.
        setTimeout(() => {
          this.isZoomed = false
        }, 300)
      }
    },
  },

  methods: {
    /**
     * Schaltet den Zoom-Status um.
     */
    toggleZoom() {
      // Zoom nur für Bilder erlauben
      if (this.item && this.item.messageType === "image") {
        this.isZoomed = !this.isZoomed
      }
    },
  },
  // --- ENDE: NEUE LOGIK ---
}
</script>

<style lang="scss" scoped>
/* START ÄNDERUNG:
  Der Container (v-card-text) ist jetzt der Scroll-Bereich.
  Standardmäßig zentriert er den Inhalt (das un-gezoomte Bild).
*/
.zoom-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* Standard: Kein Scrollen */
}

/* Wenn gezoomt, erlauben wir das Scrollen
  und richten das Bild oben links aus.
*/
.zoom-container.is-zoomed {
  overflow: auto; /* Scrollen erlauben */
  justify-content: flex-start;
  align-items: flex-start;
}

/* Das Bild selbst (Wrapper) 
*/
.fullscreen-media-content {
  /* WICHTIG: ::v-deep .secured-media-content
    zielt auf das <img>-Tag *innerhalb* der SecuredMedia-Komponente.
  */

  /* Standard-Ansicht (nicht gezoomt) */
  ::v-deep .secured-media-content {
    max-width: 90vw;
    max-height: 90vh;
    border-radius: 8px;
    cursor: zoom-in;
    transition: max-width 0.2s ease, max-height 0.2s ease;
  }

  /* Gezoomte Ansicht */
  &.zoomed-in {
    ::v-deep .secured-media-content {
      max-width: none; /* Auf volle Größe zoomen */
      max-height: none; /* Auf volle Größe zoomen */
      cursor: zoom-out;
      border-radius: 0;
    }
  }

  /* (Wir wenden die Styles nicht auf Video an, nur auf img) */
  ::v-deep video.secured-media-content {
    cursor: default;
    max-width: 90vw;
    max-height: 90vh;
  }
  &.zoomed-in {
    ::v-deep video.secured-media-content {
      cursor: default;
      max-width: 90vw;
      max-height: 90vh;
    }
  }
}
/* ENDE ÄNDERUNG */

/* (Fade-Transition Styles bleiben gleich) */
::v-deep .blur-dialog.fade-transition-enter-active {
  transition: opacity 2s ease !important;
}
::v-deep .blur-dialog.fade-transition-leave-active {
  transition: opacity 2s ease-out !important;
}
</style>
